module.exports = __webpack_public_path__ + "static/media/02_logo_41x128.68f23748.ico";